<template>
  <ProductTitledBlock
    v-if="mergedVideos.length > 0"
    class="mb-5"
    icon=""
    :title="model.title || $t('custom.product_details.videos_block_title')"
  >
    <ProductVideos :videos="mergedVideos" />
  </ProductTitledBlock>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { ProductTitledBlock, ProductVideos } from "@/shared/catalog";
import type { Product } from "@/core/api/graphql/types";

const props = defineProps<{
  product: Product;
  model: {
    title: string;
  };
}>();

const mergedVideos = computed(() => {
  const videos = props.product.videos?.items ?? [];
  const masterVideos = props.product.masterVideos?.items ?? [];

  return [...videos, ...masterVideos];
});
</script>
